import { lazy } from "react";

export const publicRoutes = [
  { path: "/", component: lazy(() => import("../../FinalPanchayath")) },
  // { path: "/CaptureOfVoters", component: lazy(() => import("../../CaptureOfVoters")) },
  // { path: "/capture-of-voters", component: lazy(() => import("../../CaptureOfVoters")) },
  // { path: "/polling-percentage", component: lazy(() => import("../../PollingPercentage")) },


  { path: "*", component: lazy(() => import("../../Components/Contacts/PageNotFound")) },
  { path: "/UnderConstruction", component: lazy(() => import("../../UnderConstruction")) },
  { path: "/TemporaryUnavailable", component: lazy(() => import("../../TemporaryUnavailable")) },

  // LOGIN
  { path: "/loginpage/:type", component: lazy(() => import("../../LoginPage")) },

  // ONLINE PAYMENTS
  { path: "/LoginHouseTaxPayment", component: lazy(() => import("../../Components/Taxes/LoginPayments-TX/LoginHouseTaxPayment")) },
  { path: "/LoginHouseTaxBalPayment", component: lazy(() => import("../../Components/Taxes/LoginPayments-TX/LoginHouseTaxBalPayment")) },
  { path: "/SwarnaPanchayatServices", component: lazy(() => import("../../Components/SwarnaPanchayatServices")) },

  // SUBS
  { path: "/donations", component: lazy(() => import("../../Components/Donations")) },
  { path: "/MiscellaneousFeeDeposit", component: lazy(() => import("../../Components/Non-Taxes/Miscellaneous/MiscellaneousFeePayment")) },
  { path: "/MiscellaneousFeeSalesGp", component: lazy(() => import("../../Components/Non-Taxes/Miscellaneous/MiscellaneousFeePayment")) },
  { path: "/MiscellaneousFeeCertificate", component: lazy(() => import("../../Components/Non-Taxes/Miscellaneous/MiscellaneousFeePayment")) },
  { path: "/MiscellaneousFeeNOCCertificate", component: lazy(() => import("../../Components/Non-Taxes/Miscellaneous/MiscellaneousFeePayment")) },
  { path: "/MiscellaneousFeeRTIDocument", component: lazy(() => import("../../Components/Non-Taxes/Miscellaneous/MiscellaneousFeePayment")) },
  { path: "/MiscellaneousFeeGarbage", component: lazy(() => import("../../Components/Non-Taxes/Miscellaneous/MiscellaneousFeePayment")) },
  { path: "/MiscellaneousFeePenalties", component: lazy(() => import("../../Components/Non-Taxes/Miscellaneous/MiscellaneousFeePayment")) },
  { path: "/MutationFeePayment", component: lazy(() => import("../../Components/Non-Taxes/Miscellaneous/MiscellaneousFeePayment")) },
  { path: "/PropertyValuationFeePayment", component: lazy(() => import("../../Components/Non-Taxes/Miscellaneous/MiscellaneousFeePayment")) },

  // DASHBOARDS
  { path: "/digitalization-dashboard", component: lazy(() => import("../../PowerBIDashboard")) },
  { path: "/dcb-dashboard", component: lazy(() => import("../../PowerBiDashboardNew")) },
  { path: "/svamitva-dashboard", component: lazy(() => import("../../SamitvaDashboard")) },
  { path: "/electricity-dashboard", component: lazy(() => import("../../ElectricityDashboard")) },
  { path: "/vehical-dashboard", component: lazy(() => import("../../VehicalMaster")) },
  { path: "/dashboards/:type", component: lazy(() => import("../../../src/Components/SideDashboard")) },
  { path: "/wages-dashboard", component: lazy(() => import("../../SvamitvaServices/WagesDashboard")) },
  { path: "/works-dashboard", component: lazy(() => import("../../SvamitvaServices/WorksManageDashBoard")) },

  { path: "/onepercentcontribution", component: lazy(() => import("../../OnePercentContribution")) },

  // CITIZEN SERVICES
  { path: "/SelfAssessmentForm", component: lazy(() => import("../../Components/Taxes/WaterSupplyServices/SelfAssesmentNewForm")) },
  { path: "/AditionAlterition", component: lazy(() => import("../../Components/Taxes/WaterSupplyServices/AditionAlterition")) },
  { path: "/TaxException", component: lazy(() => import("../../Components/Taxes/TaxExemption/TaxException")) },
  { path: "/V2HouseTaxAutoCalculation", component: lazy(() => import("../../Components/Taxes/AssesmentDetails/V2HouseTaxAutoCalculation")) },
  { path: "/GramPanchyatSwagage", component: lazy(() => import("../../Components/Taxes/WaterSupplyServices/GramPanchyatSwagage")) },
  { path: "/PlannedSupplyReport", component: lazy(() => import("../../Components/Taxes/WaterSupplyServices/PlannedSupplyReport")) },
  { path: "/RawWaterQualityReport", component: lazy(() => import("../../Components/Taxes/WaterSupplyServices/RawWaterQualityReport")) },
  { path: "/CitizenRevenueNotice", component: lazy(() => import("../../Components/Taxes/AssesmentDetails/CitizenRevenueNotice")) },
  { path: "/HouseTaxMutationApplication", component: lazy(() => import("../../Components/Taxes/Mutation/HouseTaxMutationApplication")) },
  { path: "/prt", component: lazy(() => import("../../Components/Taxes/HouseTaxPayment/HousetaxPaymentSMSView")) },
  { path: "/PropertyValuation", component: lazy(() => import("../../Components/Taxes/PropertyValuationCertificate/PropertyValuation")) },
  { path: "/PropertyValuationStatusTracking", component: lazy(() => import("../../Components/Taxes/PropertyValuationCertificate/PropertyValuationStatusTracking")) },
  { path: "/KnowYourstatusMenudetails", component: lazy(() => import("../../Components/Taxes/PropertyValuationCertificate/KnowYourstatusMenudetails")) },

  // PANCHAYATI PROFILE
  { path: "/OutsidePanchayatProfileView", component: lazy(() => import("../../Components/Taxes/Panchanyatprofile/OutsidePanchayatProfileView")) },

  // GOS & CIRCULARS
  { path: "/outsearchgos", component: lazy(() => import("../../Components/UploadGos/OutSearchGos")) },

  // CAREER
  { path: "/outnotification", component: lazy(() => import("../../Components/UploadGos/Notification")) },

  // GALLERY
  { path: "/GalleryPage", component: lazy(() => import("../../GalleryPage")) },

  // CONTACT
  { path: "/Contactus", component: lazy(() => import("../../Components/Contacts/Contactus")) },

  { path: "/UserManual", component: lazy(() => import("../../Dashboard/UserManual")) },
  { path: "/sidebar", component: lazy(() => import("../../SidebarV2")) },

  // DASHBOARD (NEW)
  { path: "/panchayatraj-dashboard", component: lazy(() => import("../../PowerBIDashboardNewTwo")) },

  // HOUSE TAX OUTSIDE
  { path: "/OutsideOwnerHouseDetails", component: lazy(() => import("../../Components/Taxes/LoginPayments-TX/OutsideOwnerHouseDetails")) },
  { path: "/outsidehousetaxchallan/:assessmentNo", component: lazy(() => import("../../Components/Taxes/LoginPayments-TX/HouseTaxPaymentChallanViewOutside")) },

  // COMMON SIDEBAR
  { path: "/mobileGoogleRecaptcha", component: lazy(() => import("../../MobilePaymentsSBI/MobileGoogleRecaptcha")) },
  { path: "/V2HouseTaxCalculationView", component: lazy(() => import("../../Components/Taxes/V2HouseTaxCalculationView")) },

  // SUPPORT LOGIN
  { path: "/SupportLoginPage", component: lazy(() => import("../../SupportLoginPage")) },

  // MASTERS
  { path: "/prCollections", component: lazy(() => import("../../Components/Masters/PrCollections")) },

  // SIDEBAR V3
  { path: "/sidebar3", component: lazy(() => import("../../SidebarV3")) },

  { path: "/adminsidebar", component: lazy(() => import("../../SidebarV3")) },
  { path: "/CronSchedulerForm", component: lazy(() => import("../../Components/CronSchedulerForm")) },
  { path: "/MobileAppPrivacyPolicy", component: lazy(() => import("../../Components/MobileAppPrivacyPolicy")) },

  // HOME PAGE

  { path: "/Disclaimer", component: lazy(() => import("../../Disclaimer")) },
  { path: "/Faq", component: lazy(() => import("../../Faq")) },
  { path: "/Helpsection", component: lazy(() => import("../../help")) },
  { path: "/webpolicy", component: lazy(() => import("../../Website Policy")) },
  { path: "/Feedback", component: lazy(() => import("../../feedback")) },
  { path: "/CopyRight", component: lazy(() => import("../../CopyRight")) },
  { path: "/PrivacyPolicy", component: lazy(() => import("../../PrivacyPolicy")) },
  { path: "/HyperLink", component: lazy(() => import("../../HyperLinkPolicy")) },
  { path: "/TermsUse", component: lazy(() => import("../../Terms")) },
  { path: "/Sitemap", component: lazy(() => import("../../SiteMap")) },

  { path: "/SvamitvaPropertyDetails", component: lazy(() => import("../../SvamitvaServices/SvamithvaPropertyDetails")) },

  { path: "/zerophace-dashboard", component: lazy(() => import("../../SvamitvaServices/ZeroFaceDashboard")) },

  {
    path: "/mutationqr/:grvApplicantId/:applPropertyId/:applntmutationId/:secretariatId",
    component: lazy(() => import("../../Components/MutationQrPdf")),
  },

  { path: "/HTCview/:assessmentNo/:transactionno", component: lazy(() => import("../../Components/Taxes/HouseTaxPayment/HouseTaxPaymentChallanScannedView")) },

  //outside tap
  { path: "/OutsideTapFeePayment", component: lazy(() => import("../../Components/Non-Taxes/TapFee/OutsideTapFeePayment")) },
  { path: "/OutsideTapFeeBalDetails", component: lazy(() => import("../../Components/Non-Taxes/TapFee/OutsideTapFeeBalDetails")) },
  { path: "/OustideOwnerTapDetails", component: lazy(() => import("../../Components/Non-Taxes/TapFee/OustideOwnerTapDetails")) },

  //outside trae
  { path: "/OutSideTradeLicensePayment", component: lazy(() => import("../../Components/Non-Taxes/TradeLicense/OutSideTradeLicensePayment")) },
  { path: "/OutsideTradeFeeBalDetails", component: lazy(() => import("../../Components/Non-Taxes/TradeLicense/OutsideTradeFeeBalDetails")) },
  { path: "/OutsideTradeDCBView", component: lazy(() => import("../../Components/Non-Taxes/TradeLicense/OustideTradeDCB")) },

  //Outside Auctions
  { path: "/OutSideAuctionFeePayment", component: lazy(() => import("../../Components/Non-Taxes/Auctions/OutSideAuctionFeePayment")) },
  { path: "/OutsideAuctionFeeDetails", component: lazy(() => import("../../Components/Non-Taxes/Auctions/OutsideAuctionFeeDetails")) },
  { path: "/outsideAuctionsView", component: lazy(() => import("../../Components/Non-Taxes/Auctions/OutsideAuctionsView")) },
  { path: "/demandnotice", component: lazy(() => import("../../Components/Taxes/AssesmentDetails/DemandNoticeCitizen")) },

  { path: "/traderenewal-qrverify/:applicationRefNo/:secrId/:villId", component: lazy(() => import("../../Components/Non-Taxes/TradeLicense/QrVerifyRenewalTradeCertificate")) },
  { path: "/NewTradeLicence", component: lazy(() => import("../../Components/Taxes/WaterSupplyServices/NewTradeLicence")) },

  { path: "/TradeLicenseClosure", component: lazy(() => import("../../Components/Non-Taxes/TradeLicenseClosure")) },

  { path: "/CitizenNewTapConnection", component: lazy(() => import("../../Components/Non-Taxes/TapFee/NewTapConnection/CitizenNewTapConnection")) },

  { path: "/ClosureOfWaterTapConnection", component: lazy(() => import("../../Components/Non-Taxes/TapFee/WaterTap/ClosureOfWaterTapConnection.js")) },

  { path: "/CitizenTradeOwnerChange", component: lazy(() => import("../../Components/Non-Taxes/TradeLicense/TradeOwnerChange/CitizenTradeOwnerChange")) },

  { path: "/TapDemandCorrectionCitizenApply", component: lazy(() => import("../../Components/Non-Taxes/TapFee/TapDemandCorrection/TapDemandCorrectionCitizenApply")) },
  { path: "/PropertyDemolish", component: lazy(() => import("../../Components/Non-Taxes/TapFee/WaterTap/PropertyDemolishvalue")) },

  { path: "/MPTCCandidateSearch", component: lazy(() => import("../../Components/Taxes/ElectionNomination/MPTCCandidateSearch")) },


  { path: "/ZptcCandidateSearch", component: lazy(() => import("../../Components/zptcandmptc/ZptcandmptcTest.js")) },


  { path: "/CountingOfVotes", component: lazy(() => import("../../Components/zptcandmptc/CountingOfVotes.jsx")) },

];
